import React from 'react';
import Icon, { ICON_NAME } from "../../../../../../components/Icon";
import { convertNumberTimeToStringTime } from "../../../../../../util/varibles/global";
import { useEditOp } from "../../EditOperationContext";

interface IProps {
}

const Duration: React.FC<IProps> = () => {
    const [activity_log] = useEditOp(state => state.activity_log);
    const [duration = activity_log[activity_log.length - 1].est_start_time - activity_log[0].est_start_time] = useEditOp(state => state.operation?.duration);

    return <div className='flex items-center gap-1'>
        <Icon icon={ICON_NAME.CLOCK_2} />
        {convertNumberTimeToStringTime(duration) || '__'}
    </div>;
};

export default Duration;